<template>
  <div id="tickets">
    <div id="container">
      <div class="box"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    // Set page title
    this.$parent.title.heading = 'Tickets';
    this.$parent.title.subheading = 'Dit zijn jouw openstaande tickets.';

    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/HelloTest.vue